import { DataBean } from "../DataBean";


export class CDPAvailableForUse extends DataBean {

    public async getCDPAvailableForUseCatalog(idContract: number, isEnabled: boolean | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCDPAvailableForUseCatalog_Number_Boolean", [idContract, isEnabled]);
    }

}